import React from 'react'
import { Box, Divider, FlexGrid, StackView } from '@telus-uds/components-web'

import { components } from '@digital-commerce/shared-utils'
import { array } from 'prop-types'
import GiftDisplay from './GiftDisplay'

const { ShouldRender } = components

const MobilityGifts = ({ gifts }) => {
  return (
    <ShouldRender when={gifts.length > 0}>
      <Box vertical={4}>
        <Divider variant={{ decorative: true }} />
      </Box>
      <FlexGrid gutter={false}>
        <FlexGrid.Row>
          <FlexGrid.Col xs={12} justifyContent="center">
            <StackView space={{ xs: 5, md: 4 }}>
              {gifts.map((gift) => (
                <GiftDisplay gift={gift} key={gift.id} />
              ))}
            </StackView>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </ShouldRender>
  )
}

MobilityGifts.propTypes = {
  gifts: array
}

MobilityGifts.defaultProps = {
  gifts: []
}

export default MobilityGifts
